import { createGlobalStyle } from 'styled-components';

import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  html {
    width: 100%;
    height: 100%;
    min-width: 20rem;
    scroll-behavior: smooth;

    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    --voca-rem-multiplier: 0.625;
    --purpur-rescale: 1;
  }
  html,
  body {
    font-family: 'TeliaSans', 'Helvetica Neue', 'Arial', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: ${getPurpurColor('functionalBlack')};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body, main {
    height: auto;
    width: 100%;
  }
  body {
    margin: 0;
    min-width: 20rem;
  }

  input {
    &:focus {
        outline: 0;
    }
  }

  button {
    cursor: pointer;
    background: transparent;
    border: 0;
    padding: 0;
    color: inherit;
    font: inherit;
    margin: 0;
  }

  img {
    vertical-align: middle;
  }

  [hidden] {
      display: none !important;
  }
`;

export default GlobalStyle;
